import React, { useState } from "react";
import "./ContactEnquirySection.css";
import axios from "axios";

const ContactEnquirySection = () => {

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    pincode: "",
    enquiry: "",
    remarks: ""
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ 
      ...formData, 
      [e.target.name]: e.target.value 
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/form/send-enquiry`, formData);
      alert("Enquiry submitted successfully!");
      
      setFormData({
        name: "",
        phone: "",
        pincode: "",
        enquiry: "",
        remarks: ""
      });
    } catch (error) {
      alert("Failed to send enquiry. Try again.");
      console.error(error);
    }

    setLoading(false);
  };

  return (
    <section className="contact-section">

      <div className="contact-grid">

        {/* LEFT SIDE — ADDRESS / CONTACT INFO */}
        <div className="contact-info">

          <h2 className="contact-heading">
            Fill out the Enquiry Form<br /> 
            <span>We will respond in 2–3 days!</span>
          </h2>

          <div className="info-block">
            <h3>📍 Address</h3>
            <p>
              1566, 9th Cross,<br />
              Little Kidz School Road,<br />
              Chandralayout, Bengaluru, Karnataka<br />
              560040
            </p>
          </div>

          <div className="info-block">
            <h3>📞 Phone</h3>
            <a href="tel:+919886855700">+91 98868 55700</a>
          </div>

          <div className="info-block">
            <h3>📧 Email</h3>
            <a href="mailto:info@niecce.com">info@niecce.com</a>
          </div>

        </div>

        {/* RIGHT SIDE — ENQUIRY FORM */}
        <div className="contact-form">
          <h3 className="form-title">First Step to Become a Teacher!</h3>

          <form className="form" onSubmit={handleSubmit}>

            <div className="form-group">
              <label>Your Name</label>
              <input
                type="text"
                name="name"
                placeholder="Enter your name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Phone</label>
              <input
                type="tel"
                name="phone"
                placeholder="Your phone number"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Area PIN Code</label>
              <input
                type="text"
                name="pincode"
                placeholder="PIN Code"
                value={formData.pincode}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Enquiring for</label>
              <select
                name="enquiry"
                value={formData.enquiry}
                onChange={handleChange}
                required
              >
                <option value="">Choose one</option>
                <option>NTT Course</option>
                <option>MTT Course</option>
                <option>PTT Course</option>
                <option>Branch / Center Info</option>
                <option>General Enquiry</option>
              </select>
            </div>

            <div className="form-group">
              <label>Remarks (Optional)</label>
              <textarea
                name="remarks"
                placeholder="Tell us anything we should know..."
                value={formData.remarks}
                onChange={handleChange}
              />
            </div>

            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? "Sending..." : "Submit"}
            </button>

          </form>
        </div>

      </div>

    </section>
  );
};

export default ContactEnquirySection;
